import { useRxDBContext } from "$global-providers/rxdb-provider/provider";
import { useEffect } from "react";

/**
 * Hook that prevents the user from leaving the page when there is unsynced data
 * Shows the browser's native "Leave site?" confirmation dialog
 */
export const usePreventUnloadWhenUnsynced = () => {
  const {
    replicationState: { hasUnsyncedChanges },
  } = useRxDBContext();

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (hasUnsyncedChanges) {
        // Modern browsers ignore custom messages, but we still need to set returnValue
        // or return a string to trigger the confirmation dialog
        event.preventDefault();
        event.returnValue = "";
        return "";
      }
    };

    if (hasUnsyncedChanges) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsyncedChanges]);
};
